import { mergeStyleSets } from '@fluentui/react';

export const dashboardStyles = mergeStyleSets({
  container: {
    padding: '20px 32px',
    background: '#fff',
    overflowX: 'hidden' as const,
    selectors: {
      '@media (max-width: 1023px)': {
        padding: '16px 20px',
      },
      '@media (max-width: 768px)': {
        padding: '12px 16px',
      },
    },
  },
  pageTitle: {
    fontSize: '24px',
    fontWeight: 600,
    color: '#000',
    margin: '0',
  },
  titleRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
    selectors: {
      '@media (max-width: 768px)': {
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '12px',
      },
    },
  },
  addCaseButton: {
    background: '#0078d4',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    padding: '10px 20px',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
  },
  titleActions: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  refreshButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    background: '#ffffff',
    color: '#0078d4',
    border: '1px solid #0078d4',
    borderRadius: '4px',
    padding: '9px 16px',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    selectors: {
      ':hover': {
        background: '#f3f9ff',
      },
      ':disabled': {
        color: '#a19f9d',
        borderColor: '#c8c6c4',
        background: '#f3f2f1',
        cursor: 'default',
      },
    },
  },
  statCardsRow: {
    display: 'flex',
    gap: '16px',
    marginBottom: '16px',
    flexWrap: 'wrap' as const,
    selectors: {
      '@media (max-width: 1023px)': {
        gap: '12px',
      },
      '@media (max-width: 768px)': {
        flexDirection: 'column',
        gap: '10px',
      },
    },
  },
  statCard: {
    flex: 1,
    minWidth: '180px',
    padding: '16px 20px',
    borderRadius: '8px',
    borderTop: '4px solid',
    boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
    cursor: 'pointer',
    background: '#fff',
    transition: 'box-shadow 0.2s',
    selectors: {
      ':hover': { boxShadow: '0 2px 8px rgba(0,0,0,0.15)' },
      ':focus-visible': { outline: '2px solid #0078d4', outlineOffset: '2px' },
      '@media (max-width: 1023px)': {
        minWidth: '140px',
        padding: '12px 16px',
      },
      '@media (max-width: 768px)': {
        minWidth: 'unset',
        width: '100%',
      },
    },
  },
  statCardActive: {
    boxShadow: '0 2px 8px rgba(0,120,212,0.3)',
    background: '#f3f9ff',
  },
  statNumber: {
    fontSize: '28px',
    fontWeight: 700,
    display: 'block',
  },
  statLabel: {
    fontSize: '11px',
    fontWeight: 600,
    color: '#555',
    letterSpacing: '0.5px',
    marginTop: '4px',
    display: 'block',
  },
  warningBanner: {
    padding: '10px 16px',
    background: '#ffffff',
    borderRadius: '4px',
    fontSize: '13px',
    fontWeight: 600,
    color: '#333',
    marginBottom: '16px',
    border: '1px solid #e5e7eb',
  },
  filtersRow: {
    display: 'flex',
    gap: '24px',
    marginBottom: '0px',
    flexWrap: 'wrap' as const,
    alignItems: 'flex-end',
    selectors: {
      '@media (max-width: 1023px)': {
        gap: '12px',
      },
      '@media (max-width: 768px)': {
        flexDirection: 'column',
        gap: '10px',
      },
    },
  },
  filterItem: {
    minWidth: '130px',
    maxWidth: '160px',
    boxSizing: 'border-box' as const,
    selectors: {
      '@media (max-width: 768px)': {
        minWidth: 'unset',
        maxWidth: 'unset',
        width: '100%',
      },
    },
  },
  filterItemCheckbox: {
    display: 'flex',
    flexDirection: 'column' as const,
    justifyContent: 'flex-end',
    minWidth: '100px',
    paddingBottom: '6px',
  },
  filterLabel: {
    fontSize: '10px',
    fontWeight: 400,
    marginBottom: '4px',
    color: '#000',
    paddingLeft: '8px',
  },
  gridContainer: {
    width: '100%',
    border: 'none',
    overflowX: 'auto' as const,
  },
  spinnerContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 80,
  },
  countText: {
    fontSize: '12px',
    color: '#505050',
    marginBottom: '8px',
  },
});

export const detailsListStyles = {
  root: {
    width: '100%',
    minWidth: 1200,
    border: 'none',
    selectors: {
      '.ms-FocusZone': {
        border: 'none',
      },
    },
  },
};
